<template>
  <el-card class="insurance-item" shadow="never">
    <div class="insurance-header" @click="toggleCollapse">
      <span class="insurance-title">
        {{ insurance.insurType }} &nbsp; 保险单号：{{ insurance.insurNum || "新保险" }}
        <span v-if="isCurrentValid" class="status active"> 有效 </span>
      </span>
      <el-button v-if="mode === 'view'" type="default" plain size="small" @click.stop="edit"
        >编辑</el-button
      >
      <el-button v-if="mode === 'edit'" type="primary" size="small" @click.stop="save"
        >保存</el-button
      >
      <el-button v-if="mode === 'edit'" type="default" plain size="small" @click.stop="cancel"
        >取消</el-button
      >
      <el-button
        v-if="mode === 'edit' && !insurance.id"
        type="default"
        plain
        size="small"
        @click.stop="deleteItem"
        >删除</el-button
      >
      <span class="arrow-icon" :class="{ rotated: expanded }">&#9660;</span>
    </div>
    <el-collapse-transition>
      <div v-show="expanded" class="insurance-body">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-width="120px"
          :disabled="mode === 'view'"
          size="small"
          class="insurance-form"
        >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="保险公司名称" prop="insurCom">
                <el-select
                  v-model="formData.insurCom"
                  placeholder="请选择保险公司名称"
                  style="width: 100%"
                  allow-create
                  filterable
                >
                  <el-option v-for="item in insurComOpts" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="保险单号" prop="insurNum">
                <el-input v-model="formData.insurNum" placeholder="请输入保险单号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="保险类型" prop="insurType">
                <el-select
                  v-model="formData.insurType"
                  placeholder="请选择保险类型"
                  style="width: 100%"
                  allow-create
                  filterable
                >
                  <el-option
                    v-for="item in insurTypeOpts"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="保费" prop="premium">
                <el-input-number v-model="formData.premium" :min="0" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生效时间" prop="insurEff">
                <el-date-picker
                  v-model="formData.insurEff"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择生效日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="到期时间" prop="insurExp">
                <el-date-picker
                  v-model="formData.insurExp"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择到期日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="车辆号牌" prop="vehicleNo">
                <el-input v-model="formData.vehicleNo" placeholder="请输入车辆号牌" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="保险文件" prop="insuranceFiles">
                <file-upload
                  v-model="formData.insuranceFiles"
                  multiple
                  uploadType="choose"
                  :filePath="$ossPath.vehicleInsurance()"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-collapse-transition>
  </el-card>
</template>

<script>
import FileUpload from "@/components/FileUpload.vue";
import { addVehicleInsurance } from "@/api";
import moment from "moment";
export default {
  name: "VehicleInsuranceItem",
  components: { FileUpload },
  props: {
    insurance: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: "view" // view/edit
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCurrentValid() {
      const { insurEff, insurExp } = this.insurance || {};
      if (insurEff && insurExp) {
        const now = moment();
        return (
          moment(insurEff).subtract(1, "day").isBefore(now) &&
          moment(insurExp).add(1, "day").isAfter(now)
        );
      }
      return false;
    }
  },
  data() {
    return {
      formData: { ...this.insurance },
      rules: {
        insurCom: [{ required: true, message: "请输入保险公司名称", trigger: "blur" }],
        insurType: [{ required: true, message: "请输入保险类型", trigger: "blur" }],
        premium: [{ required: true, message: "请输入保费", trigger: "blur" }],
        insurEff: [{ required: true, message: "请选择生效时间", trigger: "change" }],
        insurExp: [{ required: true, message: "请选择到期时间", trigger: "change" }],
        vehicleNo: [{ required: true, message: "请输入车辆号牌", trigger: "blur" }],
        insuranceFiles: [{ required: false }]
      },
      insurTypeOpts: ["交强险", "商业险", "驾乘人意外险", "承运人险"],
      insurComOpts: [
        "中国平安财产保险股份有限公司",
        "太平财产保险有限公司",
        "中国人民财产保险股份有限公司",
        "现代财产保险有限公司"
      ]
    };
  },
  watch: {
    insurance: {
      handler(val) {
        this.formData = { ...val };
      },
      deep: true
    },
    mode(val) {
      if (val === "edit") {
        this.formData = { ...this.insurance };
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit("toggleCollapse");
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        addVehicleInsurance(this.formData).then((res) => {
          this.$emit("save", res.data);
          this.$message.success("保存成功");
        });
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    edit() {
      this.$emit("edit");
    },
    deleteItem() {
      if (this.insurance.id) {
        this.$message.warning("已创建的保险无法删除");
      } else {
        this.$emit("delete");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.insurance-item {
  margin-bottom: 16px;
}

.insurance-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.insurance-title {
  flex: 1;
}

.insurance-body {
  margin-top: 16px;
}

.arrow-icon {
  margin-left: 8px;
  font-size: 16px;
  display: inline-block;
  transition: transform 0.2s;

  &.rotated {
    transform: rotate(180deg);
  }
}

.status {
  margin-left: 12px;
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;

  &.active {
    background: #67c23a;
  }

  &.inactive {
    background: #f56c6c;
  }
}
</style>
